<div [ngClass]="{ active: docsEditable }" class="files-preview-container">
  <button *ngIf="renderBtn" class="attach-btn" mat-icon-button>
    <img alt="" src="./assets/images/icons/attachment-icon.svg" />
    <input #fileDropRef (change)="fileBrowseHandler($event)" [attr.id]="'fileDropRef_' + managerIndex"
      [disabled]="Disapled" multiple [accept]="acceptExt" type="file" />
  </button>
  <div (fileDropped)="onFileDropped($event)" *ngIf="!renderBtn" [class.loading]="loading" [hidden]="!docsEditable"
    appDnd class="dnd-container">
    <input #fileDropRef (change)="fileBrowseHandler($event)" [attr.id]="'fileDropRef_' + managerIndex"
      [disabled]="Disapled" multiple [accept]="acceptExt" type="file" />
    <div>
      <svg height="25" viewBox="0 0 19 25" width="19" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11362.336-8571a2.322,2.322,0,0,1-2.336-2.3v-15.742h4.725a2.321,2.321,0,0,0,2.335-2.3V-8596h9.605a2.317,2.317,0,0,1,2.335,2.3v20.4a2.317,2.317,0,0,1-2.335,2.3Zm6.421-5.439a.738.738,0,0,0,.743.732.738.738,0,0,0,.743-.732v-5.292l1.916,1.887a.75.75,0,0,0,1.051,0,.723.723,0,0,0,0-1.035l-3.185-3.138a.749.749,0,0,0-1.05,0l-3.185,3.138a.725.725,0,0,0,0,1.035.75.75,0,0,0,1.051,0l1.915-1.887Zm-3.184-10.2a.738.738,0,0,0,.743.732h6.368a.738.738,0,0,0,.743-.732.737.737,0,0,0-.743-.732h-6.368A.738.738,0,0,0,11365.573-8586.638Zm-5.573-3.871v-.052a.729.729,0,0,1,.219-.518l4.776-4.707a.747.747,0,0,1,.524-.215h.054v4.654a.844.844,0,0,1-.849.837Z"
          fill="#4EA5A5" id="upload-icon" transform="translate(-11360 8596)" />
      </svg>
    </div>
    <h4>{{ label ? label : ('fileManager.dragAndDropFilesHere'|translate) }}</h4>
    <div>
      <span>{{'fileManager.Or'|translate}}</span>
      <label [attr.for]="'fileDropRef_' + managerIndex">{{"fileManager.browseYourFiles"|translate}}</label>
    </div>
    <div class="hint text-decoration-none">
      <div>
        {{"fileManager.supportedFormats"|translate}}:
        <ng-container *ngIf="allowedExt.length < 14">
          <span *ngFor="let item of allowedExt; index as i" class="m-0 text-bold text-uppercase">
            {{ i == 0 ? item : ('group.or' | translate) + " " + item }}
          </span>
        </ng-container>
        <span *ngIf="allowedExt.length == 14">PDF, DOC, JPG, and PNG</span>
      </div>

      <div>
        <span *ngIf="maxSize">{{"fileManager.maximumUploadFileSize"|translate}}: <span
            class="text-bold">{{maxSize}}{{'forms.MB' | translate}}</span></span>
      </div>
    </div>
  </div>
  <div *ngIf="selectedfilesCount > maxFiles && maxFiles > 1" class="has-error">
    {{ 'fileManager.maxFilesCountIs' | translate}} {{ maxFiles }}
  </div>
  <div *ngIf="selectedfilesCount > maxFiles && maxFiles === 1" class="has-error">
    {{ 'fileManager.Only One File is allowed' | translate }}
  </div>
  <div *ngIf="!validFile" class="has-error">{{invalidFileExtensions|translate}}</div>
  <div *ngIf="fileMaxSiZeErorr" class="has-error">{{"fileManager.maxFileSize"|translate}} {{maxSize}}{{'forms.MB' |
    translate}}</div>
  <div *ngIf="fileMaxNameSiZeErorr" class="has-error"></div>
  <div *ngIf="!files.length && isRequired && isSubmitted" class="has-error">
    {{required |translate}}
  </div>
  <div *ngIf="!files.length" [hidden]="docsEditable" class="dnd-container">
    <h4>{{"fileManager.noFiles"|translate}}</h4>
  </div>
  <div class="files-list">
    <div class="row">
      <div *ngFor="let file of files; let i = index" [ngClass]="{ 'col-md-6': cols == 2,'col-md-4': cols == 3 }"
        class="col-12">
        <div *ngIf="file" class="file-item">
          <div class="file-details">
            <div class="file-icon">
              <img *ngIf="fileType(file.name) == 'doc'" src="./assets/images/file-icons/file-doc-icon.svg" />
              <img *ngIf="fileType(file.name) == 'jpg'" src="./assets/images/file-icons/file-jpg-icon.svg" />
              <img *ngIf="fileType(file.name) == 'pdf'" src="./assets/images/file-icons/file-pdf-icon.svg" />
              <img *ngIf="fileType(file.name) == 'png'" src="./assets/images/file-icons/file-png-icon.svg" />
              <img *ngIf="fileType(file.name) == 'pptx'" src="./assets/images/file-icons/file-ppt-icon.svg" />
              <img *ngIf="fileType(file.name) == 'xls'" src="./assets/images/file-icons/file-xls-icon.svg" />
              <img *ngIf="fileType(file.name) == 'zip'" src="./assets/images/file-icons/file-zip-icon.svg" />
              <img *ngIf="fileType(file.name) == 'wsi'" src="./assets/images/file-icons/file-wsi-icon.svg" />
              <img
                *ngIf="fileType(file.name) == 'mp4' || fileType(file.name) == 'avi' || fileType(file.name) == 'mkv' || fileType(file.name) == 'mov'"
                src="./assets/images/file-icons/file-video-icon.svg" />
            </div>
            <div>
              <label [title]="file?.name">{{ file?.name }}</label>
              <span dir="ltr">{{ formatBytes(file?.size) }}</span>
            </div>
          </div>
          <div class="file-btn">
            <button *ngIf="!Disapled" (click)="deleteFile(i, file.id)" class="btn-delete"
              [ngClass]="{'d-flex mr-1':canDelete}">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
                <path id="ic_delete"
                  d="M56.917,3H54.592a3.757,3.757,0,0,0-3.675-3h-1.5a3.757,3.757,0,0,0-3.675,3H43.417a.75.75,0,0,0,0,1.5h.75v9.75A3.755,3.755,0,0,0,47.917,18h4.5a3.755,3.755,0,0,0,3.75-3.75V4.5h.75a.75.75,0,0,0,0-1.5Zm-7.5,9.75a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0v4.5Zm3,0a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0ZM47.3,3a2.255,2.255,0,0,1,2.122-1.5h1.5A2.255,2.255,0,0,1,53.039,3Z"
                  transform="translate(-42.667)" fill="#6b6d85" />
              </svg>
            </button>
            <a href="javascript:void(0)" class="download" (click)="downloadFile(file.path)">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path id="download_ic"
                  d="M169-786.978a1.245,1.245,0,0,1-.422-.07.987.987,0,0,1-.366-.239l-4.05-4.05a1.03,1.03,0,0,1-.323-.787,1.186,1.186,0,0,1,.323-.787,1.147,1.147,0,0,1,.8-.352,1.047,1.047,0,0,1,.8.323l2.109,2.109v-8.044a1.089,1.089,0,0,1,.323-.8A1.088,1.088,0,0,1,169-800a1.088,1.088,0,0,1,.8.323,1.089,1.089,0,0,1,.323.8v8.044l2.109-2.109a1.047,1.047,0,0,1,.8-.323,1.147,1.147,0,0,1,.8.352,1.186,1.186,0,0,1,.323.787,1.03,1.03,0,0,1-.323.787l-4.05,4.05a.987.987,0,0,1-.366.239A1.245,1.245,0,0,1,169-786.978ZM162.25-782a2.167,2.167,0,0,1-1.589-.661A2.167,2.167,0,0,1,160-784.25v-2.25a1.089,1.089,0,0,1,.323-.8,1.088,1.088,0,0,1,.8-.323,1.088,1.088,0,0,1,.8.323,1.089,1.089,0,0,1,.323.8v2.25h13.5v-2.25a1.089,1.089,0,0,1,.323-.8,1.088,1.088,0,0,1,.8-.323,1.088,1.088,0,0,1,.8.323,1.089,1.089,0,0,1,.323.8v2.25a2.167,2.167,0,0,1-.661,1.589,2.167,2.167,0,0,1-1.589.661Z"
                  transform="translate(-160 800)" fill="#6b6d85" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>